import React from "react";
import { Check, Clock } from "lucide-react";

const APP_URL = "https://app.fittrackcoach.in";

export default function FinalCTA() {
  return (
    <section className="py-24 md:py-32 relative" data-testid="final-cta-section">
      <div className="section-container">
        <div
          className="relative rounded-3xl p-8 md:p-14 text-center overflow-hidden reveal"
          style={{
            background:
              "linear-gradient(135deg, rgba(34,211,238,0.08) 0%, rgba(59,130,246,0.05) 50%, rgba(13,20,36,0.95) 100%)",
            border: "1px solid rgba(34, 211, 238, 0.25)",
          }}
        >
          <div
            aria-hidden="true"
            className="absolute inset-0 pointer-events-none"
            style={{
              background:
                "radial-gradient(ellipse at 50% 0%, rgba(34,211,238,0.25), transparent 60%), radial-gradient(ellipse at 80% 100%, rgba(59,130,246,0.18), transparent 50%)",
            }}
          />
          <div className="relative">
            <div className="chip mx-auto mb-6">Ready when you are</div>
            <h2 className="font-display text-4xl md:text-6xl leading-[1.05] max-w-3xl mx-auto">
              Give your clients a <span className="gradient-text">premium coaching experience</span>
               — without extra work.
            </h2>
            <p className="mt-5 text-white/65 max-w-xl mx-auto">
              Built for coaches who want to scale, not struggle. Join FitTrackCoach today and ship better results with less admin.
            </p>
            <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href={APP_URL}
                className="btn-primary-glow rounded-xl px-8 py-4 text-base inline-flex items-center gap-2"
                data-testid="final-cta-primary"
              >
                Start Free — Setup in 2 Minutes
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>
                </svg>
              </a>
              <a
                href="#pricing"
                className="btn-ghost rounded-xl px-8 py-4 text-base font-semibold"
                data-testid="final-cta-secondary"
              >
                See pricing
              </a>
            </div>
            <div className="mt-4 inline-flex items-center gap-2 text-sm text-cyan-300 font-semibold" data-testid="final-cta-urgency">
              <Clock size={14} /> Takes less than 2 minutes to start
            </div>
            <div className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-white/50">
              <span className="inline-flex items-center gap-1.5"><Check size={14} className="text-cyan-400"/> No credit card required</span>
              <span className="inline-flex items-center gap-1.5"><Check size={14} className="text-cyan-400"/> 10 clients free forever</span>
              <span className="inline-flex items-center gap-1.5"><Check size={14} className="text-cyan-400"/> Cancel anytime</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
